import React from 'react';
import UsersList from './components/UsersList';

const UsersView = () => (
  <UsersList />
);

export default UsersView;
